<template>
  <aha-modal
    width="auto"
    v-if="openModal"
    @hide="hideModal"
    :hide-header="true"
    :noMarginPadding="true"
  >
    <div class="wrapper-modal">
      <div class="p-2 text-right ">
        <aha-icon
          name="close"
          height="20"
          width="20"
          viewBox="0 0 24 24"
          @click="hideModal()"
          class="cursor-pointer text-base-70 hover:text-primary-90"
        />
      </div>
      <div class="text-2xl font-bold  mb-7 text-center title-plan ">
        {{ $i18nPresenter.t('Choose a plan') }}
      </div>

      <div class="flex gap-2 justify-center items-center pricing-toggle-wrapper" v-if="isVisibleToggle()">
        <div :class="{'font-bold': !isAnnual}" class="aha__save">
          {{ $i18nPresenter.t('Monthly') }}
        </div>
        <toggle-button
          :sync="true"
          :value="isAnnual"
          :width="45"
          :height="28"
          class="mb-0"
          :color="{
            checked: '#348EF6',
            unchecked: '#D3D7E1'
          }"
          @change="toggleButtonSwitch()"
        />
        <div class="flex flex-row items-center gap-1 relative" :class="{'font-bold-v2': isAnnual}">
          {{ $i18nPresenter.t('Yearly') }}
          <div class="pricing-label-discount">
            <p>{{ $i18nPresenter.t('Save up to 67%') }}</p>
          </div>
        </div>
      </div>
      <div
        v-else
        class="billing-title text-center"
      >
        {{ $i18nPresenter.t('Billing Yearly') }}
      </div>
      <div class="ml-10 mr-10">
        <PricingDesktop
          :is-editor="true"
          :planName="planName"
          @learnMore="learnMore"
          :permission="permission"
        />
      </div>

      <div class="text-center mt-6 pb-8  ">
        <span class="cursor-pointer font-bold primary  text-primary-90" @click="viewAllPlan()">
          {{ $i18nPresenter.t('View all plans & details') }}
        </span>
      </div>
    </div>
  </aha-modal>
</template>
<script >
import { mapState } from 'vuex'
import PricingDesktop from '@/components-v2/my-plan/user-pricing-v2/PricingDesktop.vue'
import Config from '@/config'
import PlanAPI from '@/api/plan'
import Pricing from '@/pricing'
import Utils from '@/util'
import featuresByPlan from '@/components-v2/my-plan/user-pricing-v2/featuresByPlan'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
    PricingDesktop,
  },
  props: {
    openModal: {
      type: Boolean,
      default: false,
    },

  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),

    isAnnual() {
      return this.planName == 'annual'
    },
  },
  data() {
    return {
      planName: 'annual',
      isPresenterPlanLoading: false,
      data: {},
      typePay: 1,
      url: '',
      isTurningOnAutoRenew: false,
      dataConfirm: {},
      autoRenewOn: false,
      isConfirmCancel: false,
      isCheckout: false,
      stripe: null,
      hasErrorOnLoadingPresenterPlan: false,
      textShowPlanEdu: true,
      permission: {
        imeMini: false,
        oneTimeSmall: false,
        oneTimeMedium: false,
        oneTimeLarge: false,
        essentialMonthly: false,
        essentialYearly: false,
        plusMonthly: false,
        plusYearly: false,
        proMonthly: false,
        proYearly: false,
        eduSmall: false,
        eduMedium: false,
        eduLarge: false,
        eduSmallYearly: false,
        eduMediumYearly: false,
        eduLargeYearly: false,
      },
    }
  },
  watch: {
    '$store.state.currentUser': function () {
      if (this.currentUser.id) {
        this.getMyPlan()
        if (this.currentUser.stripeSource === 'australia') {
          this.stripe = window.Stripe(Config.stripePublicKey)
        } else {
          this.stripe = window.Stripe(Config.singaporeStripePublishableKey)
        }
      }
    },
  },
  mounted() {
    document.body.classList.remove('no-scroll')
    if (this.currentUser.id) {
      this.getMyPlan()

      if (this.currentUser.stripeSource === 'australia') {
        this.stripe = window.Stripe(Config.stripePublicKey)
      } else {
        this.stripe = window.Stripe(Config.singaporeStripePublishableKey)
      }
    }
    this.url = Config.presenterDomain
  },
  methods: {
    viewAllPlan() {
      window.open('/apps/user-plan', '_blank')
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Choose a plan pop-up > View all plans & details',
        this.planName, {
          plan: this.currentUser.plan,
        })
    },
    toggleButtonSwitch() {
      if (this.planName === 'annual') {
        this._togglePlan('monthly')
      } else {
        this._togglePlan('annual')
      }
    },
    hideModal() {
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Choose a plan pop-up > Close', this.planName, {
        plan: this.currentUser.plan,
      })
      this.$emit('hide')
    },
    _togglePlan(plan) {
      if (!plan) return
      this.planName = plan
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Change Plan Tab',
        plan,
        {
          plan: this.currentUser.plan,
        },
      )
    },
    isVisibleToggle() {
      return this.getPrices('monthly').length > 0
    },
    getPrices(planName) {
      return featuresByPlan[planName].planPrices.filter((plan) => {
        return !this.permission[plan.permissionKey] && plan.label !== 'Free'
      })
    },
    learnMore(plan) {
      Utils.mixpanelTracking(eventCategories.MY_PLAN, 'Learn more', plan)
      const element = document.getElementById('sticky-wrapper')
      const top = element.offsetTop - 50
      window.scrollTo(0, top)
    },
    handleModalUpgradeApply() {
      this.$emit('outsideEvent')
      if (this.planForFeature === 'Pro') {
        return this.goToUpgradePage(featuresByPlan.annual.planPrices.find((plan) => plan.label === 'Pro').upgradeLink)
      }
      this.openModal = true
    },
    async getMyPlan() {
      if (this.currentUser.plan === 'free') {
        this.data.plan = this.$store.state.plan
        return
      }

      this.isPresenterPlanLoading = true
      this.hasErrorOnLoadingPresenterPlan = false

      try {
        const res = await PlanAPI.getMyPlan()
        this.data = res.body

        if (this.data.subscription) {
          this.data.subscription.plan = Pricing.getPlanByType(res.body.subscription.type)
        }
      } catch (error) {
        this.hasErrorOnLoadingPresenterPlan = true
        Utils.mixpanelTracking('User Plan', 'Get user plan', 'Get user plan failed')
        throw error
      } finally {
        this.isPresenterPlanLoading = false
      }

      Pricing._checkPermissionUpgrade(this.$store.state.plan.type, this.permission, this.data)
      if (this.$store.state.plan.type === 'essential-monthly') {
        this.permission.essentialYearly = true
      }
      if (this.$store.state.plan.type === 'plus-monthly') {
        this.permission.plusYearly = true
        this.permission.essentialYearly = true
      }
      if (this.$store.state.plan.type === 'edu-medium-yearly') {
        this.permission.essentialYearly = true
      }
    },
    goToUpgradePage(url) {
      // const plan = /content=([^&]+)/.exec(url)[1] || ''
      setTimeout(() => {
        window.open(`${Config.presenterDomain}${url}`, '_blank')
      }, 500)
    },
  },
}
</script>
<style lang="scss" scoped>
.pricing-toggle{
  &.show-edu-plan{
    justify-content: center;
  }
}
.pricing-toggle-wrapper{
  @apply flex justify-center;
  font-size : 20px;
  color: var(--base-80, #707070);
}
.aha__save{
  flex-direction: column;
}
.pricing-label-discount {

  color: var(--green-100, #15A962);
  border-radius: 4px;
  background: var(--green-10, #EBF9F1);
  font-family: Nunito;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  padding:4px 8px;
}
.font-bold-v2{
  font-weight: bold;
  color : #0A0A0A;
}
.title-plan{
color : #282E3E
}

.billing-title{
  color: var(--base-90, #313131);
  color: var(--base-90, #313131);
  font-size: 20px;
}
.wrapper-modal{
  max-height: calc(100vh - 100px);
}
</style>
